/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, Tooltip } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Roles } from 'shared/enums/Roles';
import IconButton from '../../../common/IconButton';
import useStyles from '../FOTableBodyStyle';
import { useScreenSize } from '../../../../shared/theming/useScreenSize';
import { selectAuthUserData } from '../../../../redux/features/auth/auth.slice';

export const isIncluded = (subArray, arr = []) => {
  if (subArray.length === 0) return true;
  return subArray.some((subArrayItem) => {
    return arr.includes(subArrayItem);
  });
};

const CombinedCell = (props) => {
  const { item, roles = [Roles.END_USER_ADMIN], cellData, computeCombinedCellEntries } = props;
  const [isAdmin, setIsAdmin] = React.useState(false);
  const { t } = useTranslation();
  const classes = useStyles();

  const userData = useSelector(selectAuthUserData);
  const actionEntries = computeCombinedCellEntries(item, isAdmin);

  useEffect(() => {
    if (userData && userData.roles) {
      const hasRoleAdmin = isIncluded(roles, userData.roles);

      setIsAdmin(hasRoleAdmin);
    }
  }, [roles, setIsAdmin, userData]);

  const { isExtraLargeOrBigger } = useScreenSize();

  if (cellData?.showOnNonXLDevice || isExtraLargeOrBigger) {
    return (
      <TableCell>
        <div className={classes.combinedColumn}>
          {actionEntries?.length &&
            actionEntries.map((actionEntry) => {
              if (actionEntry.tooltipText)
                return (
                  <Tooltip
                    key={actionEntry.id}
                    classes={{ tooltip: classes.tooltip }}
                    placement="top"
                    title={t(actionEntry.tooltipText)}
                    disableHoverListener={false}
                  >
                    <span>
                      <IconButton
                        id={actionEntry.id}
                        aria-label={t(actionEntry.ariaLabel)}
                        disabled={actionEntry?.disabled}
                        color="default"
                        size="small"
                        onClick={
                          actionEntry.onClick && !actionEntry?.disabled ? evt => actionEntry.onClick(item, evt) : null
                        }
                      >
                        {actionEntry.icon}
                      </IconButton>
                    </span>
                  </Tooltip>
                );

              return (
                <span key={actionEntry.id}>
                  <IconButton
                    id={actionEntry.id}
                    aria-label={t(actionEntry.ariaLabel)}
                    disabled={actionEntry.disabled}
                    color="default"
                    size="small"
                    onClick={actionEntry.onClick && !actionEntry?.disabled ? () => actionEntry.onClick(item) : null}
                  >
                    {actionEntry.icon}
                  </IconButton>
                </span>
              );
            })}
        </div>
      </TableCell>
    );
  }
  return null;
};

export default CombinedCell;
